// removed by extract-text-webpack-plugin
module.exports = {"selected":"select-cell-formatter__selected___lWY5A","checkbox":"select-cell-formatter__checkbox___RXlB0"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/grid/cell-formatters/select-cell-formatter.scss
// module id = 1337
// module chunks = 0